{
  "fr": {
    "tenant": {
      "actions": {
        "changeCompanyLogo": "Changer le logo (png requis)",
        "changeThemeColor": "Choisir une nouvelle couleur de thème"
      },
      "errors": {
        "themeColorInvalid": "Saisissez six caractères, 0-9 ou A-F. Par exemple 096553."
      },
      "labels": {
        "customerThemeColor": "Couleur du thème du client",
        "customerThemeColorExlainer": "Cette couleur sera utilisée pour le portail client. Pour le voir à l'œuvre, il suffit d'imiter l'identité d'un client.",
        "logo": "Logo"
      },
      "paused": {
        "description": "Votre compte chez {client} existe toujours, mais votre accès est désactivé pour le moment, donc la plateforme reste fermée. Un propriétaire de votre organisation peut réactiver votre accès.",
        "noAccess": "Pas d’accès",
        "open": "Ouvrir",
        "title": "Votre accès est suspendu",
        "yourOrganizations": "Vos organisations"
      },
      "picture_logo_format": {
        "round": "Logo rond",
        "square": "Logo carré"
      }
    }
  }
}
